import React, {useState} from 'react'
import { AiOutlineCloseCircle } from 'react-icons/ai'
import Inputfield from '../InputField/Inputfield'
import Radiofield from '../Radiofield/Radiofield'
import '../Addemployee/addemployee.css'
import './addrole.css'
import axios from 'axios'
import { useCookies } from 'react-cookie';

const AddRole = ({sendnotice, params}) => {
    const API = 'https://staging.sabrecwa.com/staff'
    const [cookies] = useCookies(['Token']);
    const [jobrole, setJobrole] = useState('')

    const [arrayJD, setArrayJD] = useState([])

    const handleSubmit = async() =>{
      sendnotice({
        action: "load",
        text: 'Uploading Data...'
      })
      // console.log(arrayJD)
        try {
          var config = {
            method: 'POST',
            url: `${API}/hr/create/designation`,
            data: {
              job_role: jobrole,
              job_description: arrayJD
            },
            headers: { 
              Authorization: "Bearer " + cookies.Token
            }
          };

          // console.log(config)
      
          await axios(config).then((response) => {
            // console.log(response)
            if(response.data.success === true){
              // do something
              sendnotice({
                action: "notload",
                text: response.data.message
              })
            }
          });
        } catch(e){
          if(e.message.includes('401')){
            // catch error
          } else{
            // catch error
          }
        }
    }

    const handleCountryname = (incoming) =>{
      setJobrole(incoming)
    }

    const handleClose = () =>{
      sendnotice({
        action: "close",
        text: ''
      })
    }

    const handleDescArray = (incoming) =>{
      setArrayJD(incoming.map((items) => (items.jd)))
    }

  return (
    <div className='overlay-container'>
            <div className='overlay-addemployee-container'>
                <div className='top-container-apprais-notif'>
                    <span>ADD NEW ROLE & JD</span>
                    <AiOutlineCloseCircle id='closeIcon-notifc' onClick={handleClose}/>
                </div>

                <div className='top-addemployee-container-body'>
                    <div className='addemployee-addrow'>
                        <div className='addemployee-addrow-cola'>
                            <Inputfield personname={handleCountryname} fieldlabel="Role" placehold="Enter New Job role here..." typeid="text"/>
                        </div>
                    </div>
                    <div className='addemployee-addrow'>
                        <div className='addemployee-addrow-cola'>
                            <Inputfield fieldlabel="Job description" placehold="Enter JD here..." typeid="accordion" jdarray={handleDescArray}/>
                        </div>
                    </div>
                    <div className='top-addemployee-submit-row'>
                        <button id='broadcast-buttn' onClick={handleSubmit}>SUBMIT</button>
                    </div>
                </div>
            </div>
        </div>
  )
}

export default AddRole